module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAc0lEQVR42mNgGA5AG4gdQhgYCoIYGPwoMSgAiB8D8X8QngbF7QwMf8IZGNpJNawQZhC6gTCcD7GMaJf9J2QgCBPr0sfEGgjyPjER8J9YA0GYUEQ5kGogKPbpaiDVvUz1SKFJsgGBVdRM2DTJejQpHAYHAAB+1KmsT7QmsQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure_mixed.png
// module id = XN/m
// module chunks = 1